module.exports = __webpack_public_path__ + "img/selected5-min.57be3fc9.png";